import React from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import ActionLink from "../../../../controls/ActionLink";
import Moment from "react-moment";
import TenderBase from "../components/TenderBase";
import SelectSupplierModal from "../modals/SelectSupplierModal";
import Documents from "../components/Documents";
import ShareUrlPopover from "../../popovers/ShareUrlPopover";
import {OverlayTrigger} from "react-bootstrap";
import {CopyToClipboard} from "react-copy-to-clipboard";
import {infoToast} from "../../../../utils/toasts";
import ConfirmationModal from "../../../../modals/ConfirmationModal";

const $ = window.jQuery;

class NewTender extends TenderBase {
    static propTypes = {
        data: PropTypes.object.isRequired,
        deliveryTypes: PropTypes.array.isRequired,
        payers: PropTypes.array.isRequired,
        paymentConditions: PropTypes.array.isRequired,
        onUpdate: PropTypes.func
    };
    static defaultProps = {};
    state = {
        isLoading: false,
        showArchiveConfirmationModal: false,
        showSelectSupplierModal: false,
        showDetails: false,
        editNote: false,
        noteTemp: "",
        note: this.props.data.comment,
        typeId: this.props.data.typeId,
        orderNumber: this.props.data.orderNumber,
        deliveryTypeId: this.props.data.deliveryTypeId,
        payerId: this.props.data.payerId,
        paymentConditionsId: this.props.data.paymentConditionsId
    };

    render() {
        const {data, onUpdate} = this.props;
        return (
            <div className={`panel ${this.state.isLoading ? 'form-loading' : ''}`}>
                <div className="panel-heading">
                    <span className="panel-title">
                        <Link to={this.getRelativeTenderUrl()}>
                            <strong>№ {data.tenderNumber}</strong>
                        </Link>
                        {" "}
                        <small><Moment locale="ru" format="DD.MM.YYYY HH:mm">{data.createdAt}</Moment></small>
                    </span>
                    <div className="panel-heading-controls">
                        {/*<span className="panel-heading-text text-default">*/}
                        {/*<i className="fa fa-comment-o"/> 5*/}
                        {/*<span> (<strong className="text-success">3</strong>)</span>*/}
                        {/*&nbsp;&nbsp;|&nbsp;&nbsp;*/}
                        {/*</span>*/}
                        <button type="button" className="btn btn-primary btn-xs btn-outline"
                                onClick={() => this.showSelectSupplierModal()}>
                            Выбор поставщика
                        </button>
                        <button type="button" className="btn btn-default btn-xs btn-outline btn-outline-colorless"
                                onClick={() => this.setState({showArchiveConfirmationModal: true})}>
                            <i className="fa fa-archive"/> Отправить в архив
                        </button>
                        <CopyToClipboard text={data.clipboardData}
                                         onCopy={() => infoToast("Сохранено в буфер обмена")}>
                            <button type="button" className="btn btn-default btn-xs btn-outline btn-outline-colorless">
                                <i className="fa fa-link"/> Сохранить в буфер
                            </button>
                        </CopyToClipboard>
                        <OverlayTrigger ref={el => this.shareUrlPopoverOverlay = el}
                                        trigger="click" placement="top"
                                        rootClose
                                        overlay={<ShareUrlPopover
                                            url={this.getAbsoluteTenderUrl()}
                                            close={() => this.shareUrlPopoverOverlay.hide()}/>}>
                            <button type="button" className="btn btn-default btn-xs btn-outline btn-outline-colorless">
                                <i className="fa fa-link"/> Ссылка
                            </button>
                        </OverlayTrigger>
                    </div>
                </div>
                {
                    (this.state.note || this.state.editNote) &&
                    <div className="px-block-alerts">
                        {
                            this.state.editNote
                                ? (
                                    <div className="alert alert-info">
                                        <div className="input-group">
                                            <input className="form-control"
                                                   value={this.state.noteTemp}
                                                   onChange={event => this.setState({noteTemp: event.target.value})}/>
                                            <span className="input-group-btn">
                                                <button type="button" className="btn"
                                                        onClick={() => this.updateNote()}>Сохранить</button>
                                            </span>
                                        </div>
                                    </div>
                                )
                                : (
                                    <div className="alert alert-info">
                                        <button type="button" className="close"
                                                onClick={() => this.editNote()}>
                                            <i className="fa fa-edit"/>
                                        </button>
                                        <strong>Примечание:</strong> {this.state.note}
                                    </div>
                                )
                        }
                    </div>
                }
                <div className="panel-body p-y-1" style={{position: 'relative'}}>
                    <div className="row">
                        <div className="col-sm-12">
                            <div>
                                {
                                    !this.state.note &&
                                    <div className="m-b-1">
                                        <i className="fa fa-edit"/>&nbsp;
                                        <ActionLink onClick={() => this.editNote()}>Добавить примечание</ActionLink>
                                    </div>
                                }
                                <div className="row">
                                    <div className="col-sm-3">Дата доставки</div>
                                    <div className="col-sm-9">
                                        {
                                            data.deliveryDate &&
                                            <b><Moment locale="ru"
                                                       format="DD.MM.YYYY">{data.deliveryDate}</Moment></b>
                                        }
                                        {
                                            !data.deliveryDate && "Нет даты"
                                        }
                                    </div>
                                </div>
                                <div className="row m-t-1">
                                    <div className="col-sm-3">Конечный получатель</div>
                                    <div className="col-sm-9">{data.client}</div>
                                </div>
                                <div className="row m-t-1">
                                    <div className="col-md-12">
                                        <i className={`fa ${this.state.showDetails ? "fa-caret-down" : "fa-caret-right"}`}/>&nbsp;
                                        <ActionLink
                                            onClick={() => this.setState({showDetails: !this.state.showDetails})}>
                                            Детали тендера
                                        </ActionLink>
                                    </div>
                                </div>
                                {
                                    this.state.showDetails &&
                                    <div>
                                        <div className="row m-t-1">
                                            <div className="col-sm-3">Тип тендера</div>
                                            <div className="col-sm-9">
                                                <label className="custom-control custom-radio radio-inline">
                                                    <input type="radio" className="custom-control-input"
                                                           name={`typeId-${data.tenderId}`}
                                                           value="1"
                                                           checked={this.state.typeId === 1}
                                                           onChange={event => this.updateTypeId(parseInt(event.target.value))}/>
                                                    <span className="custom-control-indicator"/>
                                                    <strong>Покупка</strong>
                                                </label>
                                                <label className="custom-control custom-radio radio-inline">
                                                    <input type="radio" className="custom-control-input"
                                                           name={`typeId-${data.tenderId}`}
                                                           value="2"
                                                           checked={this.state.typeId === 2}
                                                           onChange={event => this.updateTypeId(parseInt(event.target.value))}/>
                                                    <span className="custom-control-indicator"/>
                                                    <strong>Продажа</strong>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row m-t-1">
                                            <div className="col-sm-3">Адрес доставки</div>
                                            <div className="col-sm-9">{data.deliveryAddress}</div>
                                        </div>
                                        <div className="row m-t-1">
                                            <div className="col-sm-3">Номер заказа</div>
                                            <div className="col-sm-4">
                                                {
                                                    data.canEditOrderNumber
                                                        ? (
                                                            <input type="text" className="form-control" placeholder="Нет данных"
                                                                   value={this.state.orderNumber}
                                                                   onChange={event => this.updateOrderNumber(event.target.value)}/>
                                                        )
                                                        : this.state.orderNumber || "Нет данных"
                                                }
                                            </div>
                                        </div>
                                        <div className="row m-t-1">
                                            <div className="col-sm-3">Доставка</div>
                                            <div className="col-sm-4">
                                                <select className="form-control"
                                                        value={this.state.deliveryTypeId}
                                                        onChange={event => this.updateDeliveryTypeId(event.target.value)}>
                                                    {this.props.deliveryTypes.map(deliveryType =>
                                                        <option key={deliveryType.id} value={deliveryType.id}>
                                                            {deliveryType.text}
                                                        </option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="row m-t-1">
                                            <div className="col-sm-3">Клиент</div>
                                            <div className="col-sm-4">
                                                <select className="form-control"
                                                        value={this.state.payerId}
                                                        onChange={event => this.updatePayerId(event.target.value)}>
                                                    {this.props.payers.map(payer =>
                                                        <option key={payer.id} value={payer.id}>
                                                            {payer.text}
                                                        </option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="row m-t-1">
                                            <div className="col-sm-3">Условия оплаты</div>
                                            <div className="col-sm-4">
                                                <select className="form-control"
                                                        value={this.state.paymentConditionsId}
                                                        onChange={event => this.updatePaymentConditionsId(event.target.value)}>
                                                    {this.props.paymentConditions.map(paymentCondition =>
                                                        <option key={paymentCondition.id} value={paymentCondition.id}>
                                                            {paymentCondition.text}
                                                        </option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {data.items.map(item =>
                                    <div key={item.id} className="row m-t-1">
                                        <div className="col-md-8">
                                            <strong className="font-size-14">{item.name}</strong>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <div className="col-md-6">Ставка клиента</div>
                                                <div className="col-md-6"><b>{item.clientRate}&nbsp;р. с НДС</b></div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">Количество</div>
                                                <div className="col-md-6"><b>{item.count}&nbsp;шт.</b></div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {
                        data.isAdvert &&
                        <span className="label label-warning label-ribbon right label-outline">
                            Из объявления
                        </span>
                    }
                    {
                        this.state.typeId === 1 &&
                        <span className="label label-primary label-ribbon label-ribbon-bottom right">
                            Покупка
                        </span>
                    }
                    {
                        this.state.typeId === 2 &&
                        <span className="label label-danger label-ribbon label-ribbon-bottom right">
                            Продажа
                        </span>
                    }
                </div>
                <div className="panel-footer">
                    <Documents tenderId={data.tenderId}/>
                </div>
                <ConfirmationModal show={this.state.showArchiveConfirmationModal}
                                   onHide={() => this.setState({showArchiveConfirmationModal: false})}
                                   onConfirm={() => this.sendToArchive()}>
                    Вы действительно хотите отправить тендер №{data.tenderNumber} в архив?
                </ConfirmationModal>
                <SelectSupplierModal tenderId={data.tenderId}
                                     show={this.state.showSelectSupplierModal}
                                     onHide={() => {
                                         this.handleSelectSupplierModalClose();
                                         if (onUpdate) onUpdate();
                                         $(document).trigger('fetchCounters');
                                     }}/>
            </div>
        );
    }

    showSelectSupplierModal() {
        this.setState({showSelectSupplierModal: true});
    }

    handleSelectSupplierModalClose() {
        this.setState({showSelectSupplierModal: false});
    }
}

export default NewTender;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/Tenders/New/NewTender.js